import React from "react"
import { GlobalStyles } from "./src/styles/globalStyles"
import GlobalFonts from "./src/styles/fonts"

export const wrapRootElement = ({ element }) => (
  <>
    <GlobalStyles />
    <GlobalFonts />
    {element}
  </>
)
